import type { TargetDefinition, TargetInfo } from '@/types/webflash';
import { STM32F4 } from './stm32f4';
import { STM32F1 } from './stm32f1';
import { STM32G0 } from './stm32g0';

// All registered target definitions
const TARGETS: TargetDefinition[] = [STM32F4, STM32F1, STM32G0];

/**
 * Target MCU database — identifies MCUs by SWD IDCODE.
 */
export class TargetDB {
  /**
   * Look up a target by its SWD/JTAG IDCODE.
   * Returns a TargetInfo if found, or a generic "Unknown" target.
   */
  static identify(idcode: number): TargetInfo {
    for (const target of TARGETS) {
      if (target.idcodes.includes(idcode)) {
        return {
          idcode,
          partNumber: target.partNumber,
          flashSize: target.flashSize,
          ramSize: target.ramSize,
          cpuType: target.cpuType,
          hasHardwareCRC: target.hasHardwareCRC,
        };
      }
    }

    // Unknown target — return basic info from IDCODE
    return {
      idcode,
      partNumber: `Unknown (0x${idcode.toString(16).toUpperCase()})`,
      flashSize: 0,
      ramSize: 0,
      cpuType: 'CM3',
      hasHardwareCRC: false,
    };
  }

  /**
   * Get the full target definition by part number.
   */
  static getDefinition(partNumber: string): TargetDefinition | undefined {
    return TARGETS.find((t) => t.partNumber === partNumber);
  }

  /**
   * Get all registered target definitions.
   */
  static getAll(): TargetDefinition[] {
    return [...TARGETS];
  }
}
